'use strict';
import {module} from '../app';

module.controller('OtherStudyDetailsCtrl', [
  '$scope', '$stateParams', 'otherStudyDetailsViewModel', '$rootScope', 
  function ($scope, $stateParams, viewModel, $rootScope) {
    let worklistId = $stateParams.worklistId;
    $scope.vm = new viewModel(worklistId);
    $scope.vm.isOnline = () => $rootScope.isOnline();
  }
]);



// WEBPACK FOOTER //
// ./src/scripts/controllers/otherStudyDetails.js